import { useEffect, useState } from 'react';

const IPAD_WIDTH = 1366;
const IPAD_HEIGHT = 1024;
const MARGIN = 48;

export function useIpadScale(): number {
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const compute = () => {
      const w = window.innerWidth;
      const h = window.innerHeight;
      const s = Math.min(w / (IPAD_WIDTH + MARGIN), h / (IPAD_HEIGHT + MARGIN));
      setScale(Math.max(0.1, s));
    };
    compute();
    window.addEventListener('resize', compute);
    return () => window.removeEventListener('resize', compute);
  }, []);

  return scale;
}
